export const SOFTLINE_API_SUBKUNDEN = '/v1/subkunden/entities';
